<template>
  <div class="l-container UsersIndex">
    現在表示数 {{max}}
    <!-- <div>{{obj}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span>
      <template v-if="this.sortColumn === 'id'">ID</template>
      <template v-if="this.sortColumn === 'user'">user</template>
      <template v-if="this.sortColumn === 'name'">name</template>
      <template v-if="this.sortColumn === 'email'">email</template>
      <template v-if="this.sortColumn === 'type'">権限</template>
      <template v-if="this.sortColumn === 'office_id'">office_id</template>
      <template v-if="this.sortColumn === 'created_at'">作成日</template>
      <template v-if="this.sortColumn === 'updated_at'">更新日</template>
      <template v-if="this.sortColumn === 'hide_flag'">削除</template>
       : {{sortState}}
    </span>

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>

    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('user')" v-bind:class="{ 'active': user }">User</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">name</btn>
        <btn class="m-btn--column" @click.native="switchV('email')" v-bind:class="{ 'active': email }">email</btn>
        <btn class="m-btn--column" @click.native="switchV('type')" v-bind:class="{ 'active': type }">権限</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">office_id</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
        <btn class="m-btn--column" @click.native="switchV('updated_at')" v-bind:class="{ 'active': updated_at }">更新日</btn>
        <btn class="m-btn--column" @click.native="switchV('hide_flag')" v-bind:class="{ 'active': hide_flag }">削除</btn>
      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">
      <table-c>
        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c>検索</td-c>
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="user"><td-c><input v-model="search.user" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="name"><td-c><input v-model="search.name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="email"><td-c><input v-model="search.email" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="type">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.type" :options="Type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="office_id">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.office_id" :options="orderedOffices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="updated_at"><td-c><input v-model="search.updated_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="hide_flag">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.hide_flag" :options="Hide_flag" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c>除外</td-c>
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="user"><td-c><input v-model="search.not_user" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="name"><td-c><input v-model="search.not_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="email"><td-c><input v-model="search.not_email" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="type">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.not_type" :options="Type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="office_id">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.not_office_id" :options="orderedOffices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="updated_at"><td-c><input v-model="search.not_updated_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="hide_flag">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.not_hide_flag" :options="Hide_flag" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="user"><th-c @click.native='sort("user")'>User</th-c></template>
          <template v-if="name"><th-c @click.native='sort("name")'>name</th-c></template>
          <template v-if="email"><th-c @click.native='sort("email")'>email</th-c></template>
          <template v-if="type"><th-c @click.native='sort("type")'>権限</th-c></template>
          <template v-if="office_id"><th-c @click.native='sort("office_id")'>office_id</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
          <template v-if="updated_at"><th-c @click.native='sort("updated_at")'>更新日</th-c></template>
          <template v-if="hide_flag"><th-c @click.native='sort("hide_flag")'>削除</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in filteredUsers" :key="list.id">
          <template v-if="list.id == edit_id.edit_id">
            <td-c @click.native="cancelUser(list)" class="del" style="position: relative">戻る</td-c>
            <td-c @click.native="patchUser(list)" class="del" style="position: relative">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="user">
              <td-c style="border: solid 3px #41B883"><input type="text" v-model="list.user" style="font-weight: bold"></td-c>
            </template>
            <template v-if="name"><td-c>{{list.name}}</td-c></template>
            <template v-if="email">
              <td-c style="border: solid 3px #41B883"><input type="text" v-model="list.email" style="font-weight: bold"></td-c>
            </template>
            <template v-if="type">
              <td-c class="select" style="border: solid 3px #41B883">
                <multiselect v-model="watchPatch.type" :options="Type" label="name" :show-labels="false" placeholder=""></multiselect>
              </td-c>
            </template>
            <template v-if="office_id">
              <td-c v-if="list.office_id === 0"></td-c>
              <td-c v-if="list.office_id === 1">仙台</td-c>
              <td-c v-if="list.office_id === 2">札幌</td-c>
              <td-c v-if="list.office_id === 3">名古屋</td-c>
              <td-c v-if="list.office_id === 4">福岡</td-c>
              <td-c v-if="list.office_id === 5">新宿</td-c>
              <td-c v-if="list.office_id === 6">大宮</td-c>
              <td-c v-if="list.office_id === 7">高松</td-c>
              <td-c v-if="list.office_id === 8">高崎</td-c>
              <td-c v-if="list.office_id === 9">東京</td-c>
              <td-c v-if="list.office_id === 10">大阪</td-c>
            </template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
            <template v-if="updated_at"><td-c>{{list.updated_at.substring(0, 10)}}</td-c></template>
            <template v-if="hide_flag">
              <td-c class="select" style="border: solid 3px #41B883">
                <multiselect v-model="watchPatch.hide_flag" :options="Hide_flag" label="name" :show-labels="false" placeholder=""></multiselect>
              </td-c>
            </template>
          </template>

          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteUser(list)" class="del" style="position: relative">削除</td-c>
            <td-c @click.native="editUser(list)" class="del" style="position: relative">編集</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="user"><td-c>{{list.user}}</td-c></template>
            <template v-if="name"><td-c>{{list.name}}</td-c></template>
            <template v-if="email"><td-c>{{list.email}}</td-c></template>
            <template v-if="type"><td-c>{{list.type}}</td-c></template>
            <template v-if="office_id">
              <td-c v-if="list.office_id === 0"></td-c>
              <td-c v-if="list.office_id === 1">仙台</td-c>
              <td-c v-if="list.office_id === 2">札幌</td-c>
              <td-c v-if="list.office_id === 3">名古屋</td-c>
              <td-c v-if="list.office_id === 4">福岡</td-c>
              <td-c v-if="list.office_id === 5">新宿</td-c>
              <td-c v-if="list.office_id === 6">大宮</td-c>
              <td-c v-if="list.office_id === 7">高松</td-c>
              <td-c v-if="list.office_id === 8">高崎</td-c>
              <td-c v-if="list.office_id === 9">東京</td-c>
              <td-c v-if="list.office_id === 10">大阪</td-c>
            </template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
            <template v-if="updated_at"><td-c>{{list.updated_at.substring(0, 10)}}</td-c></template>
            <template v-if="hide_flag">
              <td-c v-if="list.hide_flag === 0">稼働中</td-c>
              <td-c v-if="list.hide_flag === 1">削除</td-c>
            </template>
          </template>
        </tr-c>
      </table-c>
    </div>

  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/users/search?limit=' + config.LIMIT

// var TIMER = null
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'user',
  pageNames: 'users'
}

let _ = window._
export default {
  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      sortState: '昇順',
      sortColumn: 'id',

      id: true,
      user: true,
      name: true,
      email: true,
      type: true,
      office_id: true,
      created_at: true,
      updated_at: true,
      hide_flag: true,

      userPatch: {
        type: '',
        office_id: '',
        hide_flag: ''
      },

      watchPatch: {
        type: '',
        office_id: '',
        hide_flag: ''
      },

      search: {
        // 検索
        id: '',
        user: '',
        name: '',
        email: '',
        type: '',
        office_id: '',
        created_at: '',
        updated_at: '',
        hide_flag: '',

        // 除外
        not_id: '',
        not_user: '',
        not_name: '',
        not_email: '',
        not_type: '',
        not_office_id: '',
        not_created_at: '',
        not_updated_at: '',
        not_hide_flag: ''
      },

      watchSearch: {
        type: '',
        office_id: '',
        hide_flag: '',

        not_type: '',
        not_office_id: '',
        not_hide_flag: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    Type () {
      return this.$store.getters['users/type']
    },

    Hide_flag () {
      return this.$store.getters['users/hide_flag']
    },

    offices () {
      return this.$store.getters.offices
    },

    orderedOffices () {
      return _.orderBy(this.offices, 'id', 'asc')
    },

    users () {
      return this.$store.getters.users
    },

    // order By
    orderedUsers () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.users, this.sortColumn, 'desc')
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.users, this.sortColumn)
      }
    },

    // filter
    filteredUsers () {
      let self = this
      return self.orderedUsers.filter((user) => {
        return user.id !== 0 && user.hide_flag === 0
      })
    }
  },
  watch: {
    'watchPatch.type': function (now, old) {
      if (now) {
        this.userPatch.type = now.value
      } else {
        this.userPatch.type = ''
      }
    },

    'watchPatch.office_id': function (now, old) {
      if (now) {
        this.userPatch.office_id = now.id
      } else {
        this.userPatch.office_id = ''
      }
    },

    'watchPatch.hide_flag': function (now, old) {
      if (now) {
        this.userPatch.hide_flag = now.value
      } else {
        this.userPatch.hide_flag = ''
      }
    },

    'watchSearch.type': function (now, old) {
      if (now) {
        this.search.type = now.value
      } else {
        this.search.type = ''
      }
    },

    'watchSearch.not_type': function (now, old) {
      if (now) {
        this.search.not_type = now.value
      } else {
        this.search.not_type = ''
      }
    },

    'watchSearch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watchSearch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watchSearch.hide_flag': function (now, old) {
      if (now) {
        this.search.hide_flag = now.value
      } else {
        this.search.hide_flag = ''
      }
    },

    'watchSearch.not_hide_flag': function (now, old) {
      if (now) {
        this.search.not_hide_flag = now.value
      } else {
        this.search.not_hide_flag = ''
      }
    }
  },
  methods: {
    switchV (col) {
      this[col] = !this[col]
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    reset () {
      this.id = false
      this.user = false
      this.name = false
      this.email = false
      this.type = false
      this.office_id = false
      this.created_at = false
      this.updated_at = false
      this.hide_flag = false
    },

    all () {
      this.id = true
      this.user = true
      this.name = true
      this.email = true
      this.type = true
      this.office_id = true
      this.created_at = true
      this.updated_at = true
      this.hide_flag = true
    },

    linkUser (user) {
      this.$router.push({name: 'userindex', params: { id: user.id }})
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.search.user = ''
      this.search.name = ''
      this.search.email = ''
      this.watchSearch.type = 0
      this.watchSearch.office_id = 0
      this.search.created_at = ''
      this.search.updated_at = ''
      this.watchSearch.hide_flag = 0

      this.search.not_id = ''
      this.search.not_user = ''
      this.search.not_name = ''
      this.search.not_email = ''
      this.watchSearch.not_type = 0
      this.watchSearch.not_office_id = 0
      this.search.not_created_at = ''
      this.search.not_updated_at = ''
      this.watchSearch.not_hide_flag = { name: '削除', value: 1 }

      this.searchTable()
    },

    editUser (list) {
      this.edit_id.edit_id = list.id

      const type = {}
      type.name = list.type
      type.value = list.type
      this.watchPatch.type = type

      if (list.office_id === 0) {
        this.userPatch.office_id = 0
      } else {
        const office_id = this.offices.filter(function (office) {
          return office.id === list.office_id
        })[0]
        this.watchPatch.office_id = office_id
      }

      const hide_flag = this.Hide_flag.filter(function (h) {
        return h.value === list.hide_flag
      })[0]
      this.watchPatch.hide_flag = hide_flag
    },

    // postUser () {
    //   this.$store.dispatch('postUser', this.user)
    // },

    deleteUser (list) {
      this.$store.dispatch('deleteUser', {
        list: list,
        reset: this.resetSearch
      })
    },

    cancelUser (list) {
      this.$store.dispatch('cancelUser', {
        list: list,
        edit_id: this.edit_id,
        reset: this.resetSearch
      })
    },

    patchUser (list) {
      this.$store.dispatch('patchUser', {
        list: list,
        user: this.userPatch,
        edit_id: this.edit_id,
        reset: this.resetSearch
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('UsersSearch')
      let obj = JSON.parse(getjson)

      vm.search.id = obj['id']
      vm.search.user = obj['user']
      vm.search.name = obj['name']
      vm.search.email = obj['email']
      vm.watchSearch.type = obj['type']
      vm.watchSearch.office_id = obj['office_id']
      vm.search.created_at = obj['created_at']
      vm.search.updated_at = obj['updated_at']
      vm.watchSearch.hide_flag = obj['hide_flag']

      vm.search.not_id = obj['not_id']
      vm.search.not_user = obj['not_user']
      vm.search.not_name = obj['not_name']
      vm.search.not_email = obj['not_email']
      vm.watchSearch.not_type = obj['not_type']
      vm.watchSearch.not_office_id = obj['not_office_id']
      vm.search.not_created_at = obj['not_created_at']
      vm.search.not_updated_at = obj['not_updated_at']
      vm.watchSearch.not_hide_flag = obj['not_hide_flag']

      // console.log(obj)
      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      id: this.search.id,
      user: this.search.user,
      name: this.search.name,
      email: this.search.email,
      type: this.watchSearch.type,
      office_id: this.watchSearch.office_id,
      created_at: this.search.created_at,
      updated_at: this.search.updated_at,
      hide_flag: this.watchSearch.hide_flag,

      not_id: this.search.not_id,
      not_user: this.search.not_user,
      not_name: this.search.not_name,
      not_email: this.search.not_email,
      not_type: this.watchSearch.not_type,
      not_office_id: this.watchSearch.not_office_id,
      not_created_at: this.search.not_created_at,
      not_updated_at: this.search.not_updated_at,
      not_hide_flag: this.watchSearch.not_hide_flag
    }
    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('UsersSearch', setjson)
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 205px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  width: 80px;
  &:hover {
    background: black;
    color: white;
  }
}
</style>
<style lang="scss">
.UsersIndex {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// UsersIndex.vue?2e9d95d2